import React from "react";
import { ALT_CAMPAIGN } from "../globals";
import Helpers from "../services/helpers";

export const EbayLogo = ({ query }) => (
  <a
    className="EbayLogo"
    href={Helpers.generatePartnerLinkFromQuery(ALT_CAMPAIGN, query)}
    target="_blank"
    rel="noreferrer"
  >
    <img src="/ebay-logo.gif" alt="Ebay logo" />
  </a>
);
